export default class Item{
    constructor(id,name,url){
        this.id=id;
        this.name=name;
        this.url=url;
        this.markForDelete=false;
        this.markForUpdate=false;
    }
    toggleMarkForDelete(itemObject){
        console.log("Model [item.js] toggling delete",itemObject);
        itemObject.markForDelete = !itemObject.markForDelete;
        console.log("Model [item.js] toggled delete",itemObject);
    }
    toggleMarkForUpdate(itemObject){
        console.log("Model [item.js] toggling update",itemObject);
        itemObject.markForUpdate = !itemObject.markForUpdate;
        console.log("Model [item.js] toggled update",itemObject);

    }
}


// WEBPACK FOOTER //
// ./src/Model/item.js